import api from '../..'

const GetLoadPercentage = (id: number) => {
  return api
    .get<{
      loadPercentage: number
      processing: boolean
      processed: boolean
      isValidated: boolean
    }>(`administration/block_scorm/${id}/load_percentage`)
    .then(({ data }) => {
      return data
    })
}

export default GetLoadPercentage
